// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* BREAKPOINTS */
@keyframes F1Theme_cloudsFade__UsgC9 {
  100% {
    opacity: 1;
  }
}
.F1Theme_background__iimyh {
  opacity: 0;
  animation: F1Theme_cloudsFade__UsgC9 ease forwards;
  animation-duration: 3s;
  animation-delay: 0.5s;
}
.F1Theme_background__iimyh .F1Theme_clouds__puymE {
  color: var(--whiteAlpha);
  animation-duration: 50s;
}
.F1Theme_background__iimyh .F1Theme_clouds__puymE > svg {
  transform: scaleX(-1);
}
.F1Theme_background__iimyh .F1Theme_clouds__puymE > svg:nth-child(1) {
  font-size: 50px;
  bottom: 30%;
  left: 1%;
}
.F1Theme_background__iimyh .F1Theme_clouds__puymE > svg:nth-child(2) {
  font-size: 150px;
  bottom: 50%;
  left: 15%;
}
.F1Theme_background__iimyh .F1Theme_clouds__puymE > svg:nth-child(3) {
  font-size: 60px;
  bottom: 60%;
  left: 40%;
}
.F1Theme_background__iimyh .F1Theme_clouds__puymE > svg:nth-child(4) {
  font-size: 70px;
  bottom: 40%;
  left: 60%;
}
.F1Theme_background__iimyh .F1Theme_clouds__puymE > svg:nth-child(5) {
  font-size: 100px;
  bottom: 40%;
  left: 80%;
}

.F1Theme_foreground__6-wO4 {
  opacity: 0;
  animation: F1Theme_cloudsFade__UsgC9 ease forwards;
  animation-duration: 3s;
}
.F1Theme_foreground__6-wO4 .F1Theme_clouds__puymE {
  color: var(--white);
  animation-duration: 40s;
}
.F1Theme_foreground__6-wO4 .F1Theme_clouds__puymE > svg:nth-child(1) {
  font-size: 30px;
  bottom: 40%;
  left: 10%;
}
.F1Theme_foreground__6-wO4 .F1Theme_clouds__puymE > svg:nth-child(2) {
  font-size: 50px;
  bottom: 55%;
  left: 15%;
}
.F1Theme_foreground__6-wO4 .F1Theme_clouds__puymE > svg:nth-child(3) {
  font-size: 35px;
  bottom: 35%;
  left: 45%;
}
.F1Theme_foreground__6-wO4 .F1Theme_clouds__puymE > svg:nth-child(4) {
  font-size: 60px;
  bottom: 50%;
  left: 55%;
}
.F1Theme_foreground__6-wO4 .F1Theme_clouds__puymE > svg:nth-child(5) {
  font-size: 55px;
  bottom: 45%;
  left: 70%;
}

.F1Theme_clouds__puymE {
  width: 100%;
  height: 100%;
  position: absolute;
  transition: opacity 0.5s ease;
  animation: F1Theme_cloudsMove__EH13d infinite linear;
}
@keyframes F1Theme_cloudsMove__EH13d {
  100% {
    transform: translateX(-100%);
  }
}
.F1Theme_clouds__puymE:last-child {
  left: 100%;
}
.F1Theme_clouds__puymE > svg {
  position: absolute;
}

.F1Theme_sun__9juAp {
  position: absolute;
  left: -1%;
  top: 10%;
  width: 100px;
  height: 100px;
  border-radius: 50%;
  background: #efc10e;
  z-index: -1;
  transition: background 0.3s ease;
}

.F1Theme_moon__G-S4X {
  position: absolute;
  color: transparent;
  font-size: 50px;
  top: 10%;
  left: 90vw;
  z-index: -1;
  transition: color 0.3s ease;
}

.nightMode .F1Theme_background__iimyh .F1Theme_clouds__puymE {
  opacity: 0.2;
}
.nightMode .F1Theme_sun__9juAp {
  background: transparent;
}
.nightMode .F1Theme_moon__G-S4X {
  color: lightyellow;
}
.nightMode .F1Theme_foreground__6-wO4 .F1Theme_clouds__puymE {
  opacity: 0;
}`, "",{"version":3,"sources":["webpack://./src/core/_breakpoints.scss","webpack://./src/views/Template/components/Themes/F1Theme/F1Theme.module.scss"],"names":[],"mappings":"AAAA,gBAAA;ACEA;EACE;IACE,UAAA;EAAF;AACF;AAEA;EACE,UAAA;EACA,kDAAA;EACA,sBAAA;EACA,qBAAA;AAAF;AACE;EACE,wBAAA;EACA,uBAAA;AACJ;AAAI;EACE,qBAAA;AAEN;AADM;EACE,eAAA;EACA,WAAA;EACA,QAAA;AAGR;AADM;EACE,gBAAA;EACA,WAAA;EACA,SAAA;AAGR;AADM;EACE,eAAA;EACA,WAAA;EACA,SAAA;AAGR;AADM;EACE,eAAA;EACA,WAAA;EACA,SAAA;AAGR;AADM;EACE,gBAAA;EACA,WAAA;EACA,SAAA;AAGR;;AAEA;EACE,UAAA;EACA,kDAAA;EACA,sBAAA;AACF;AAAE;EACE,mBAAA;EACA,uBAAA;AAEJ;AAAM;EACE,eAAA;EACA,WAAA;EACA,SAAA;AAER;AAAM;EACE,eAAA;EACA,WAAA;EACA,SAAA;AAER;AAAM;EACE,eAAA;EACA,WAAA;EACA,SAAA;AAER;AAAM;EACE,eAAA;EACA,WAAA;EACA,SAAA;AAER;AAAM;EACE,eAAA;EACA,WAAA;EACA,SAAA;AAER;;AAGA;EAEE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,6BAAA;EAMA,oDAAA;AANF;AACE;EACE;IACE,4BAAA;EACJ;AACF;AAEE;EACE,UAAA;AAAJ;AAEE;EACE,kBAAA;AAAJ;;AAGA;EACE,kBAAA;EACA,SAAA;EACA,QAAA;EACA,YAAA;EACA,aAAA;EACA,kBAAA;EACA,mBAAA;EACA,WAAA;EACA,gCAAA;AAAF;;AAEA;EACE,kBAAA;EACA,kBAAA;EACA,eAAA;EACA,QAAA;EACA,UAAA;EACA,WAAA;EACA,2BAAA;AACF;;AAGI;EACE,YAAA;AAAN;AAGE;EACE,uBAAA;AADJ;AAGE;EACE,kBAAA;AADJ;AAII;EACE,UAAA;AAFN","sourcesContent":["/* BREAKPOINTS */\n@mixin breakpoint-up($point) {\n  @if $point == sm {\n    @media (min-width: 576px) {\n      @content;\n    }\n  } @else if $point == md {\n    @media (min-width: 768px) {\n      @content;\n    }\n  } @else if $point == lg {\n    @media (min-width: 992px) {\n      @content;\n    }\n  } @else if $point == xl {\n    @media (min-width: 1200px) {\n      @content;\n    }\n  }\n}\n\n@mixin breakpoint-down($point) {\n  @if $point == xs {\n    @media (max-width: 575.98px) {\n      @content;\n    }\n  } @else if $point == sm {\n    @media (max-width: 767.98px) {\n      @content;\n    }\n  } @else if $point == md {\n    @media (max-width: 991.98px) {\n      @content;\n    }\n  } @else if $point == lg {\n    @media (max-width: 1199.98px) {\n      @content;\n    }\n  }\n}\n","@import \"core/_breakpoints.scss\";\n\n@keyframes cloudsFade {\n  100% {\n    opacity: 1;\n  }\n}\n.background {\n  opacity: 0;\n  animation: cloudsFade ease forwards;\n  animation-duration: 3s;\n  animation-delay: 0.5s;\n  .clouds {\n    color: var(--whiteAlpha);\n    animation-duration: 50s;\n    > svg {\n      transform: scaleX(-1);\n      &:nth-child(1) {\n        font-size: 50px;\n        bottom: 30%;\n        left: 1%;\n      }\n      &:nth-child(2) {\n        font-size: 150px;\n        bottom: 50%;\n        left: 15%;\n      }\n      &:nth-child(3) {\n        font-size: 60px;\n        bottom: 60%;\n        left: 40%;\n      }\n      &:nth-child(4) {\n        font-size: 70px;\n        bottom: 40%;\n        left: 60%;\n      }\n      &:nth-child(5) {\n        font-size: 100px;\n        bottom: 40%;\n        left: 80%;\n      }\n    }\n  }\n}\n.foreground {\n  opacity: 0;\n  animation: cloudsFade ease forwards;\n  animation-duration: 3s;\n  .clouds {\n    color: var(--white);\n    animation-duration: 40s;\n    > svg {\n      &:nth-child(1) {\n        font-size: 30px;\n        bottom: 40%;\n        left: 10%;\n      }\n      &:nth-child(2) {\n        font-size: 50px;\n        bottom: 55%;\n        left: 15%;\n      }\n      &:nth-child(3) {\n        font-size: 35px;\n        bottom: 35%;\n        left: 45%;\n      }\n      &:nth-child(4) {\n        font-size: 60px;\n        bottom: 50%;\n        left: 55%;\n      }\n      &:nth-child(5) {\n        font-size: 55px;\n        bottom: 45%;\n        left: 70%;\n      }\n    }\n  }\n}\n.clouds {\n  // border: 1px solid red;\n  width: 100%;\n  height: 100%;\n  position: absolute;\n  transition: opacity 0.5s ease;\n  @keyframes cloudsMove {\n    100% {\n      transform: translateX(-100%);\n    }\n  }\n  animation: cloudsMove infinite linear;\n  &:last-child {\n    left: 100%;\n  }\n  > svg {\n    position: absolute;\n  }\n}\n.sun {\n  position: absolute;\n  left: -1%;\n  top: 10%;\n  width: 100px;\n  height: 100px;\n  border-radius: 50%;\n  background: #efc10e;\n  z-index: -1;\n  transition: background 0.3s ease;\n}\n.moon {\n  position: absolute;\n  color: transparent;\n  font-size: 50px;\n  top: 10%;\n  left: 90vw;\n  z-index: -1;\n  transition: color 0.3s ease;\n}\n:global(.nightMode) {\n  .background {\n    .clouds {\n      opacity: 0.2;\n    }\n  }\n  .sun {\n    background: transparent;\n  }\n  .moon {\n    color: lightyellow;\n  }\n  .foreground {\n    .clouds {\n      opacity: 0;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"background": `F1Theme_background__iimyh`,
	"cloudsFade": `F1Theme_cloudsFade__UsgC9`,
	"clouds": `F1Theme_clouds__puymE`,
	"foreground": `F1Theme_foreground__6-wO4`,
	"cloudsMove": `F1Theme_cloudsMove__EH13d`,
	"sun": `F1Theme_sun__9juAp`,
	"moon": `F1Theme_moon__G-S4X`
};
export default ___CSS_LOADER_EXPORT___;
